export default "__VITE_PUBLIC_ASSET__6112b64e__"